module.exports = __webpack_public_path__ + "static/media/East-India.c4046f86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/East-India.jpg
// module id = 1000
// module chunks = 0